export default "__VITE_ASSET__C738UBmU__"